import React from 'react';
import { Link } from 'gatsby';
import Swiper from 'react-id-swiper';

// Components
import { Wrapper, Inner, Title, Item } from './files';

// Context
import ContextConsumer from '../../contextProvider';

const CarouselSimilar = ({ itemData }) => {
  const params = {
    slidesPerView: 2,
    spaceBetween: 15,
    autoplay: {
      delay: 3500
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  };

  return (
    <ContextConsumer>
      {({ location }) => {
        let preSlug;
        let titleAll;
        if (location.pathname.includes('rooms')) {
          preSlug = '/rooms';
          titleAll = 'Rooms';
        } else if (location.pathname.includes('apartments')) {
          preSlug = '/apartments';
          titleAll = 'Apartments';
        } else if (location.pathname.includes('specials')) {
          preSlug = '/specials';
          titleAll = 'Specials';
        } else if (location.pathname.includes('events')) {
          preSlug = '/events';
          titleAll = 'Events';
        } else {
          preSlug = null;
          titleAll = null;
        }

        return (
          <Wrapper>
            <Inner>
              <Title>
                <h1>Not what you&apos;re looking for?</h1>
                <h2>Try one of these</h2>
              </Title>
              <Swiper {...params}>
                {itemData.map(({ node: item }) => {
                  let linkTo;
                  if (location.pathname.includes('rooms')) {
                    linkTo = item.seoContent.slug;
                  } else if (location.pathname.includes('apartments')) {
                    linkTo = item.seoContent.slug;
                  } else if (location.pathname.includes('specials')) {
                    linkTo = item.seoContent.slug;
                  } else if (location.pathname.includes('events')) {
                    linkTo = item.fields.seoContent.slug + `/` + item.fields.id;
                  } else {
                    linkTo = null;
                  }
                  let linkTitle;
                  if (location.pathname.includes('rooms')) {
                    linkTitle = item.seoContent.pageTitle;
                  } else if (location.pathname.includes('apartments')) {
                    linkTitle = item.seoContent.pageTitle;
                  } else if (location.pathname.includes('specials')) {
                    linkTitle = item.seoContent.pageTitle;
                  } else if (location.pathname.includes('events')) {
                    linkTitle = item.fields.seoContent.pageTitle;
                  } else {
                    linkTitle = null;
                  }
                  return (
                    <Link
                      className="carousel-item"
                      key={item.id}
                      to={`${preSlug}/${linkTo}/`}
                      title={linkTitle}
                    >
                      <Item location={location} item={item} />
                    </Link>
                  );
                })}
              </Swiper>
              <Title>
                <Link
                  className="button"
                  to={`${preSlug}/`}
                  title={`View all ${titleAll}`}
                >
                  View all {titleAll}
                </Link>
              </Title>
            </Inner>
          </Wrapper>
        );
      }}
    </ContextConsumer>
  );
};

export default CarouselSimilar;
